// extracted by mini-css-extract-plugin
export var closed = "_bg-1";
export var resizer = "_bg-0";